import React from 'react'
import { IconEye } from '@tabler/icons'
import { CButton } from '../Common'
import { useExchangeAll } from '../../hooks/trade/exchangeAll'
import { Text } from '../../../styles/reactnative'

const ExchangeName = ({ exchange_id }: any) => {
	const { data } = useExchangeAll(false)
	const exchange = data?.find((item: any) => item.id === exchange_id)

	return <Text>{exchange?.code}</Text>
}

export default React.memo(ExchangeName)
